import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { getSignedAssetUrl, useStore } from '@mcn-platform/models';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
const AssetDownloadLink = ({ name, asset, onDownload }) => {
    const [url, setUrl] = useState(undefined);
    const store = useStore();
    useEffect(() => {
        getSignedAssetUrl(asset, undefined, store).then((signedUrl) => {
            setUrl(signedUrl);
        });
    }, [asset, asset?.syncState, store]);
    return (_jsx(Button, { variant: "outlined", className: "site-system-button-primary", disabled: !url, startIcon: url ? _jsx(DownloadIcon, {}) : '', component: "a", href: url, download: true, target: "_blank", rel: "noopener noreferrer", onClick: onDownload, children: `Download: ${name || asset?.name?.substring(0, asset.name.lastIndexOf('.'))}` }));
};
export default observer(AssetDownloadLink);
//# sourceMappingURL=AssetDownloadLink.js.map